import script from "./MyScheduleTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MyScheduleTab.vue?vue&type=script&setup=true&lang=js"

import "./MyScheduleTab.vue?vue&type=style&index=0&id=b0805616&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0805616"]])

export default __exports__